import { StatusCodes } from "http-status-codes";
import { EnhancementResponse } from "../../../interfaces/IEnhancement";
import { EnhancementData } from "../../../interfaces/IEnhancementForCghs";
import Axios from "../../../utils/axiosInterceptor";
import { API_URL, PATIENT_APIS } from "../../../utils/constants";
import {
  IClaimRes,
  IClaimSubmissionResponse,
} from "../../../interfaces/IPreAuthClaim";

export const fetchPortalDataCghs = async (caseId: number, visitId: number) => {
  try {
    const res = await Axios.get(
      `${PATIENT_APIS.CGHS_SERVICE}/${caseId}/visitInfo/${visitId}/getAllCasePreAuthByCaseIdAndVisitId`
    );
    return res.data;
  } catch (error) {
    console.error("Failed to get portalData:", error);
    throw new Error("Failed to get portal data");
  }
};

export const fetchPortalDataCghsNew = async (
  caseId: number,
  visitId: number
) => {
  try {
    const res = await Axios.get(
      `${PATIENT_APIS.CGHS_AB_NEW_SERVICE}/${caseId}/visitInfo/${visitId}/getAllCasePreAuthByCaseIdAndVisitId`
    );
    return res.data;
  } catch (error) {
    console.error("Failed to get portalData:", error);
    throw new Error("Failed to get portal data");
  }
};

export const submitIdCghs = async (
  caseId: number,
  visitId: number,
  schemeId: number,
  formData: any
) => {
  try {
    const res = await Axios.patch(
      `${PATIENT_APIS.CGHS_SERVICE}/${caseId}/visitInfo/${visitId}/schemeId/${schemeId}`,
      formData
    );
    return res.data;
  } catch (error) {
    throw new Error("Failed to Update Id");
  }
};

export const submitIdCghsNew = async (
  caseId: number,
  visitId: number,
  schemeId: number,
  formData: any
) => {
  try {
    const res = await Axios.patch(
      `${PATIENT_APIS.CGHS_AB_NEW_SERVICE}/${caseId}/visitInfo/${visitId}/schemeId/${schemeId}`,
      formData
    );
    return res.data;
  } catch (error) {
    throw new Error("Failed to Update Id");
  }
};

export const updateDraftCghs = async (
  caseId: number,
  visitId: number,
  casePreAuthId: number,
  formData: any
) => {
  try {
    const response = await Axios.patch(
      `${PATIENT_APIS.CGHS_SERVICE}/${caseId}/visitInfo/${visitId}/casePreAuthId/${casePreAuthId}`,
      formData
    );
    return response.data;
  } catch (error: any) {
    console.error("Cannot update Pre Auth details:", error?.response?.data);
    throw new Error(error?.response?.data || "Cannot update Pre Auth details");
  }
};

export const updateDraftCghsNew = async (
  caseId: number,
  visitId: number,
  casePreAuthId: number,
  formData: any
) => {
  try {
    const response = await Axios.patch(
      `${PATIENT_APIS.CGHS_AB_NEW_SERVICE}/${caseId}/visitInfo/${visitId}/casePreAuthId/${casePreAuthId}`,
      formData
    );
    return response.data;
  } catch (error: any) {
    console.error("Cannot update Pre Auth details:", error?.response?.data);
    throw new Error(error?.response?.data || "Cannot update Pre Auth details");
  }
};

export const saveDraftCghs = async (
  caseId: number,
  visitId: number,
  formData: any
) => {
  try {
    const response = await Axios.post(
      `${PATIENT_APIS.CGHS_SERVICE}/${caseId}/visitInfo/${visitId}/casePreAuth`,
      formData
    );
    return response.data;
  } catch (error: any) {
    console.error("Cannot save Pre Auth details:", error?.response?.data);
    throw new Error(error?.response?.data || "Cannot save Pre Auth details");
  }
};

export const saveDraftCghsNew = async (
  caseId: number,
  visitId: number,
  formData: any
) => {
  try {
    const response = await Axios.post(
      `${PATIENT_APIS.CGHS_AB_NEW_SERVICE}/${caseId}/visitInfo/${visitId}/casePreAuth`,
      formData
    );
    return response.data;
  } catch (error: any) {
    console.error("Cannot save Pre Auth details:", error?.response?.data);
    throw new Error(error?.response?.data || "Cannot save Pre Auth details");
  }
};

//for portal registration
export const registerPatientPortalCghs = async (
  portalMetaDataId: number,
  data: any
) => {
  try {
    const response = await Axios.post(
      `${PATIENT_APIS.REGISTER_PORTAL_CGHS}/${portalMetaDataId}/patientPortalRegistration`,
      data
    );
    return response.data;
  } catch (error: any) {
    throw new Error(
      error?.response?.data || "Unable to do Portal Registration"
    );
  }
};

export const registerPatientPortalCghsNew = async (
  portalMetaDataId: number,
  data: any
) => {
  try {
    const response = await Axios.post(
      `${PATIENT_APIS.REGISTER_PORTAL_CGHS_NEW}/${portalMetaDataId}/patientPortalRegistration`,
      data
    );
    return response.data;
  } catch (error: any) {
    throw new Error(
      error?.response?.data.message || "Unable to do Portal Registration"
    );
  }
};

export const fetchPreAuthToPortalCghs = async (
  caseId: number,
  visitId: number,
  payload: any
): Promise<any> => {
  try {
    const response = await Axios.post(
      `${PATIENT_APIS.PREAUTH_DATA}/api/cghs/cases/${caseId}/visitInfo/${visitId}/initiateCasePreAuth`,
      payload
    );
    return response.data;
  } catch (error: any) {
    console.error("Cannot post Pre Auth details:", error?.response?.data);
    throw new Error(error?.response?.data || "Cannot post Pre Auth details");
  }
};

export const fetchPreAuthToPortalCghsNew = async (
  caseId: number,
  visitId: number,
  payload: any
): Promise<any> => {
  try {
    const response = await Axios.post(
      `${PATIENT_APIS.PREAUTH_DATA}/api/cghs_new/cases/${caseId}/visitInfo/${visitId}/initiateCasePreAuth`,
      payload
    );
    return response.data;
  } catch (error: any) {
    console.error("Cannot post Pre Auth details:", error?.response?.data);
    throw new Error(error?.response?.data || "Cannot post Pre Auth details");
  }
};

export const deleteProcedureCghs = async (portalId: number, data: any) => {
  try {
    const response = await Axios.put(
      `${PATIENT_APIS.CGHS_DELETE_PROCEDURE}/${portalId}/casePreAuthCGHS_Procedure`,
      data
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteProcedureCghsNew = async (portalId: number, data: any) => {
  try {
    const response = await Axios.put(
      `${PATIENT_APIS.CGHS_DELETE_PROCEDURE_NEW}/${portalId}/casePreAuthCGHS_Procedure`,
      data
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchEnhancementDataServiceCghs = async (
  caseId: string | number,
  visitId: string | number
) => {
  const response = await Axios.get(
    `${PATIENT_APIS.CGHS_GET_ENHANCEMENT_DATA}/${caseId}/visitInfo/${visitId}/getAll`
  );
  return response.data;
};

export const fetchEnhancementDataServiceCghsNew = async (
  caseId: string | number,
  visitId: string | number
) => {
  const response = await Axios.get(
    `${PATIENT_APIS.CGHS_NEW_GET_ENHANCEMENT_DATA}/${caseId}/visitInfo/${visitId}/getAll`
  );
  return response.data;
};

//to fetch procedures in enhancement of cghs/capf
export const fetchEnhancementProcedureCghs = async (
  caseId: number,
  visitId: number,
  schemeId: number
) => {
  try {
    const response = await Axios.get(
      `${PATIENT_APIS.CGHS_GET_ENHANCEMENT_DATA}/${caseId}/visitInfo/${visitId}/schemeId/${schemeId}/procedures`
    );
    return response.data;
  } catch (error) {
    throw new Error("Procedures are not getting fetched");
  }
};

export const fetchEnhancementProcedureCghsNew = async (
  caseId: number,
  visitId: number,
  schemeId: number,
  isResubmissionStage: boolean = false
) => {
  try {
    const response = await Axios.get(
      `${PATIENT_APIS.CGHS_NEW_GET_ENHANCEMENT_DATA}/${caseId}/visitInfo/${visitId}/schemeId/${schemeId}/procedures`,
      {
        headers: {
          isResubmissionStage: String(isResubmissionStage),
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error("Procedures are not getting fetched");
  }
};

export const enhancementServiceCghs = {
  getEnhancementData: async (
    caseId: number | undefined,
    visitInfoId: number | undefined,
    portalMetaDataId: number | null
  ): Promise<EnhancementResponse> => {
    try {
      const response = await Axios.get<EnhancementResponse>(
        `${PATIENT_APIS.CGHS_GET_ENHANCEMENT_DATA}/${caseId}/visitInfo/${visitInfoId}/portalMetaData/${portalMetaDataId}/caseEnhancement`
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching enhancement data:", error);
      throw error;
    }
  },
  saveEnhancementData: async (
    caseId: number | undefined,
    visitInfoId: number | undefined,
    portalMetaDataId: number,
    caseEnhancementId: string | null,
    payload: any
  ): Promise<void> => {
    try {
      let response;
      const baseUrl = `${PATIENT_APIS.CGHS_GET_ENHANCEMENT_DATA}/${caseId}/visitInfo/${visitInfoId}/portalMetaData`;

      // POST request
      response = await Axios.post(
        `${baseUrl}/${portalMetaDataId}/caseEnhancement`,
        payload
      );

      if (response.status !== 200 && response.status !== 201) {
        throw new Error("Failed to save enhancement data");
      }
    } catch (error) {
      console.error("Error saving enhancement data:", error);
      throw error;
    }
  },
};

export const enhancementServiceCghsNew = {
  getEnhancementData: async (
    caseId: number | undefined,
    visitInfoId: number | undefined,
    portalMetaDataId: number | null
  ): Promise<EnhancementResponse> => {
    try {
      const response = await Axios.get<EnhancementResponse>(
        `${PATIENT_APIS.CGHS_NEW_GET_ENHANCEMENT_DATA}/${caseId}/visitInfo/${visitInfoId}/portalMetaData/${portalMetaDataId}/caseEnhancement`
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching enhancement data:", error);
      throw error;
    }
  },
  saveEnhancementData: async (
    caseId: number | undefined,
    visitInfoId: number | undefined,
    portalMetaDataId: number,
    caseEnhancementId: string | null,
    payload: any
  ): Promise<void> => {
    try {
      let response;
      const baseUrl = `${PATIENT_APIS.CGHS_NEW_GET_ENHANCEMENT_DATA}/${caseId}/visitInfo/${visitInfoId}/portalMetaData`;

      // POST request
      response = await Axios.post(
        `${baseUrl}/${portalMetaDataId}/caseEnhancement`,
        payload
      );

      if (response.status !== 200 && response.status !== 201) {
        throw new Error("Failed to save enhancement data");
      }
    } catch (error) {
      console.error("Error saving enhancement data:", error);
      throw error;
    }
  },
};

//cghs discharge
export const dischargeServiceCghs = {
  getDischargeData: async (
    caseId: number | undefined,
    visitInfoId: number | undefined
  ) => {
    try {
      const response = await Axios.get(
        `${PATIENT_APIS.CGHS_NEW_SERVICE}/${caseId}/visitInfo/${visitInfoId}/caseDischarges`
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching discharge data:", error);
      throw error;
    }
  },
  saveDischargeData: async (
    caseId: number | undefined,
    visitInfoId: number | undefined,
    portalId: number | undefined,
    caseDischargeId: number | null,
    payload: any
  ): Promise<void> => {
    try {
      let response;
      const baseUrl = `${PATIENT_APIS.CGHS_NEW_SERVICE}/${caseId}/visitInfo/${visitInfoId}/portalMetaData`;

      if (caseDischargeId === null) {
        // POST request
        response = await Axios.post(
          `${baseUrl}/${portalId}/caseDischarges`,
          payload
        );
      } else {
        // PATCH request
        response = await Axios.patch(
          `${baseUrl}/${portalId}/caseDischarge/${caseDischargeId}/caseDischarges`,
          payload
        );
      }

      if (response.status !== 200 && response.status !== 201) {
        throw new Error("Failed to save enhancement data");
      }
    } catch (error) {
      console.error("Error saving enhancement data:", error);
      throw error;
    }
  },
  saveDischargeDataInEdgePro: async (
    caseId: number | undefined,
    visitInfoId: number | undefined,
    portalId: number | undefined,
    caseDischargeId: number | null,
    payload: any
  ): Promise<any> => {
    try {
      let response;
      const baseUrl = `${PATIENT_APIS.CGHS_NEW_SERVICE}/${caseId}/visitInfo/${visitInfoId}/portalMetaData`;
      // POST request
      if (caseDischargeId === null) {
        response = await Axios.post(
          `${baseUrl}/${portalId}/createCaseDischarge`,
          payload
        );
      } else {
        response = await Axios.patch(
          `${baseUrl}/${portalId}/caseDischarge/${caseDischargeId}/createCaseDischarge`,
          payload
        );
      }

      if (response.status !== 200 && response.status !== 201) {
        throw new Error("Failed to save enhancement data");
      }

      return response;
    } catch (error) {
      console.error("Error saving enhancement data:", error);
      throw error;
    }
  },

  saveIntimateDischarge: async (
    caseId: number | undefined,
    visitInfoId: number | undefined,
    portalMetaDataId: number | undefined,
    payload: any
  ): Promise<any> => {
    try {
      let response;
      const baseUrl = `${PATIENT_APIS.CGHS_NEW_SERVICE}/${caseId}/visitInfo/${visitInfoId}/portalMetaData/${portalMetaDataId}/createCaseDischargeIntimation`;
      // POST request

      response = await Axios.post(`${baseUrl}`, payload);

      if (response.status !== 200 && response.status !== 201) {
        throw new Error("Failed to save intimate discharge data");
      }
      return response;
    } catch (error) {
      console.error("Error saving intimate discharge data:", error);
      // throw error;
      throw new Error("Failed to save intimate discharge data");
    }
  },
  updateClaimId: async (
    formData: any,
    caseId: number | undefined,
    visitId: number | undefined,
    schemeId: number | undefined
  ): Promise<any> => {
    try {
      let response;
      const baseUrl = `${API_URL}/api/cases/${caseId}/visitInfo/${visitId}/schemeId/${schemeId}`;

      response = await Axios.patch(`${baseUrl}`, formData);

      if (response.status !== 200 && response.status !== 201) {
        throw new Error("Failed to update claim Id ");
      }
      return response;
    } catch (error) {
      console.error("Failed to update claim Id:", error);
      // throw error;
      throw new Error("Failed to update claim Id");
    }
  },
};

export const dischargeServiceCghsNew = {
  getDischargeData: async (
    caseId: number | undefined,
    visitInfoId: number | undefined
  ) => {
    try {
      const response = await Axios.get(
        `${PATIENT_APIS.CGHS_NEW_AB_SERVICE}/${caseId}/visitInfo/${visitInfoId}/caseDischarges`
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching discharge data:", error);
      throw error;
    }
  },
  saveDischargeData: async (
    caseId: number | undefined,
    visitInfoId: number | undefined,
    portalId: number | undefined,
    caseDischargeId: number | null,
    payload: any
  ): Promise<void> => {
    try {
      let response;
      const baseUrl = `${PATIENT_APIS.CGHS_NEW_AB_SERVICE}/${caseId}/visitInfo/${visitInfoId}/portalMetaData`;

      if (caseDischargeId === null) {
        // POST request
        response = await Axios.post(
          `${baseUrl}/${portalId}/caseDischarges`,
          payload
        );
      } else {
        // PATCH request
        response = await Axios.patch(
          `${baseUrl}/${portalId}/caseDischarge/${caseDischargeId}/caseDischarges`,
          payload
        );
      }

      if (response.status !== 200 && response.status !== 201) {
        throw new Error("Failed to save enhancement data");
      }
    } catch (error) {
      console.error("Error saving enhancement data:", error);
      throw error;
    }
  },
  saveDischargeDataInEdgePro: async (
    caseId: number | undefined,
    visitInfoId: number | undefined,
    portalId: number | undefined,
    caseDischargeId: number | null,
    payload: any
  ): Promise<any> => {
    try {
      let response;
      const baseUrl = `${PATIENT_APIS.CGHS_NEW_AB_SERVICE}/${caseId}/visitInfo/${visitInfoId}/portalMetaData`;
      // POST request
      if (caseDischargeId === null) {
        response = await Axios.post(
          `${baseUrl}/${portalId}/createCaseDischarge`,
          payload
        );
      } else {
        response = await Axios.patch(
          `${baseUrl}/${portalId}/caseDischarge/${caseDischargeId}/createCaseDischarge`,
          payload
        );
      }

      if (response.status !== 200 && response.status !== 201) {
        throw new Error("Failed to save enhancement data");
      }

      return response;
    } catch (error) {
      console.error("Error saving enhancement data:", error);
      throw error;
    }
  },

  saveIntimateDischarge: async (
    caseId: number | undefined,
    visitInfoId: number | undefined,
    portalMetaDataId: number | undefined,
    payload: any
  ): Promise<any> => {
    try {
      let response;
      const baseUrl = `${PATIENT_APIS.CGHS_NEW_AB_SERVICE}/${caseId}/visitInfo/${visitInfoId}/portalMetaData/${portalMetaDataId}/createCaseDischargeIntimation`;
      // POST request

      response = await Axios.post(`${baseUrl}`, payload);

      if (response.status !== 200 && response.status !== 201) {
        throw new Error("Failed to save intimate discharge data");
      }
      return response;
    } catch (error) {
      console.error("Error saving intimate discharge data:", error);
      // throw error;
      throw new Error("Failed to save intimate discharge data");
    }
  },
  updateClaimId: async (
    formData: any,
    caseId: number | undefined,
    visitId: number | undefined,
    schemeId: number | undefined
  ): Promise<any> => {
    try {
      let response;
      const baseUrl = `${API_URL}/api/cases/${caseId}/visitInfo/${visitId}/schemeId/${schemeId}`;

      response = await Axios.patch(`${baseUrl}`, formData);

      if (response.status !== 200 && response.status !== 201) {
        throw new Error("Failed to update claim Id ");
      }
      return response;
    } catch (error) {
      console.error("Failed to update claim Id:", error);
      // throw error;
      throw new Error("Failed to update claim Id");
    }
  },
};

export const getPreAuthClaimCghs = async (
  caseId: number,
  visitId: number,
  portalId: number
) => {
  try {
    const response = await Axios.get(
      `${PATIENT_APIS.CGHS_NEW_SERVICE}/${caseId}/visitInfo/${visitId}/caseClaimSubmission`
    );

    if (response.status === StatusCodes.OK) {
      return { claimSubmissionRes: response.data, status: response.status };
    } else {
      return {
        errorMessage: "Cannot get claim details",
        status: response.status,
      };
    }
  } catch (error: any) {
    console.error("Cannot get claim details:", error);
    throw new Error("Please, Try again later");
  }
};

export const getPreAuthClaimCghsNew = async (
  caseId: number,
  visitId: number,
  portalId: number
) => {
  try {
    const response = await Axios.get(
      `${PATIENT_APIS.CGHS_NEW_AB_SERVICE}/${caseId}/visitInfo/${visitId}/caseClaimSubmission`
    );

    if (response.status === StatusCodes.OK) {
      return { claimSubmissionRes: response.data, status: response.status };
    } else {
      return {
        errorMessage: "Cannot get claim details",
        status: response.status,
      };
    }
  } catch (error: any) {
    console.error("Cannot get claim details:", error);
    throw new Error("Please, Try again later");
  }
};

export const postPreAuthClaimToEdgeProCghs = async (
  data: IClaimRes,
  caseId: number,
  visitId: number,
  portalId: number,
  caseClaimId: number | null
): Promise<IClaimSubmissionResponse> => {
  try {
    let response;
    const baseUrl = `${PATIENT_APIS.CGHS_NEW_SERVICE}/${caseId}/visitInfo/${visitId}/portalMetaData`;
    if (caseClaimId === null) {
      // POST request
      response = await Axios.post(
        `${baseUrl}/${portalId}/createCaseClaim`,
        data
      );
    } else {
      response = await Axios.patch(
        `${baseUrl}/${portalId}/caseClaim/${caseClaimId}/createCaseClaim`,
        data
      );
    }
    if (response.status === StatusCodes.OK) {
      return { claimSubmissionRes: response.data, status: response.status };
    } else {
      return {
        errorMessage: response?.data,
        status: response.status,
      };
    }
  } catch (error) {
    console.error("Cannot post claim details:", error);
    throw new Error("Cannot post claim details");
  }
};

export const postPreAuthClaimToEdgeProCghsNew = async (
  data: IClaimRes,
  caseId: number,
  visitId: number,
  portalId: number,
  caseClaimId: number | null
): Promise<IClaimSubmissionResponse> => {
  try {
    let response;
    const baseUrl = `${PATIENT_APIS.CGHS_NEW_AB_SERVICE}/${caseId}/visitInfo/${visitId}/portalMetaData`;
    if (caseClaimId === null) {
      // POST request
      response = await Axios.post(
        `${baseUrl}/${portalId}/createCaseClaim`,
        data
      );
    } else {
      response = await Axios.patch(
        `${baseUrl}/${portalId}/caseClaim/${caseClaimId}/createCaseClaim`,
        data
      );
    }
    if (response.status === StatusCodes.OK) {
      return { claimSubmissionRes: response.data, status: response.status };
    } else {
      return {
        errorMessage: response?.data,
        status: response.status,
      };
    }
  } catch (error) {
    console.error("Cannot post claim details:", error);
    throw new Error("Cannot post claim details");
  }
};

export const intimateClaimCghs = async (
  data: IClaimRes,
  caseId: number,
  visitId: number,
  portalId: number,
  caseClaimId: number | null
): Promise<IClaimSubmissionResponse> => {
  try {
    let response;
    const baseUrl = `${PATIENT_APIS.CGHS_NEW_SERVICE}/${caseId}/visitInfo/${visitId}/portalMetaData/${portalId}/caseClaimIntimate`;
    response = await Axios.post(`${baseUrl}`, data);
    if (response.status === StatusCodes.OK) {
      return { claimSubmissionRes: response.data, status: response.status };
    } else {
      return {
        errorMessage: response?.data,
        status: response.status,
      };
    }
  } catch (error) {
    console.error("Cannot intimate claim details:", error);
    throw new Error("Cannot intimate claim details");
  }
};

export const intimateClaimCghsNew = async (
  data: IClaimRes,
  caseId: number,
  visitId: number,
  portalId: number,
  caseClaimId: number | null
): Promise<IClaimSubmissionResponse> => {
  try {
    let response;
    const baseUrl = `${PATIENT_APIS.CGHS_NEW_AB_SERVICE}/${caseId}/visitInfo/${visitId}/portalMetaData/${portalId}/caseClaimIntimate`;
    response = await Axios.post(`${baseUrl}`, data);
    if (response.status === StatusCodes.OK) {
      return { claimSubmissionRes: response.data, status: response.status };
    } else {
      return {
        errorMessage: response?.data,
        status: response.status,
      };
    }
  } catch (error) {
    console.error("Cannot intimate claim details:", error);
    throw new Error("Cannot intimate claim details");
  }
};

export const postPreAuthClaimCghs = async (
  data: IClaimRes,
  caseId: number,
  visitId: number,
  portalId: number
): Promise<IClaimSubmissionResponse> => {
  try {
    const response = await Axios.post(
      `${PATIENT_APIS.CGHS_NEW_SERVICE}/${caseId}/visitInfo/${visitId}/portalMetaData/${portalId}/caseClaimSubmission`,
      data
    );
    if (response.status === StatusCodes.OK) {
      return { claimSubmissionRes: response.data, status: response.status };
    } else {
      return {
        errorMessage: response?.data,
        status: response.status,
      };
    }
  } catch (error: any) {
    console.error("Cannot post claim details:", error?.response?.data);
    throw new Error(error?.response?.data || "Cannot post claim details");
  }
};

export const postPreAuthClaimCghsNew = async (
  data: IClaimRes,
  caseId: number,
  visitId: number,
  portalId: number
): Promise<IClaimSubmissionResponse> => {
  try {
    const response = await Axios.post(
      `${PATIENT_APIS.CGHS_NEW_AB_SERVICE}/${caseId}/visitInfo/${visitId}/portalMetaData/${portalId}/caseClaimSubmission`,
      data
    );
    if (response.status === StatusCodes.OK) {
      return { claimSubmissionRes: response.data, status: response.status };
    } else {
      return {
        errorMessage: response?.data,
        status: response.status,
      };
    }
  } catch (error: any) {
    console.error("Cannot post claim details:", error?.response?.data);
    throw new Error(error?.response?.data || "Cannot post claim details");
  }
};

export const getProcedureFromClaim = async (
  caseId: number,
  visitId: number
) => {
  try {
    const response = await Axios.get(
      `${PATIENT_APIS.CGHS_NEW_SERVICE}/${caseId}/visitInfo/${visitId}/billAuditProcedure`
    );

    return response?.data;
  } catch (error: any) {
    console.error("Cannot get procedure from claim:", error);
    throw new Error(
      error?.response?.data
        ? typeof error?.response?.data === "string"
          ? error?.response?.data
          : "Please, Try again later"
        : "Please, Try again later"
    );
  }
};

export const getProcedureFromClaimNew = async (
  caseId: number,
  visitId: number
) => {
  try {
    const response = await Axios.get(
      `${PATIENT_APIS.CGHS_NEW_AB_SERVICE}/${caseId}/visitInfo/${visitId}/billAuditProcedure`
    );

    return response?.data;
  } catch (error: any) {
    console.error("Cannot get procedure from claim:", error);
    throw new Error(
      error?.response?.data
        ? typeof error?.response?.data === "string"
          ? error?.response?.data
          : "Please, Try again later"
        : "Please, Try again later"
    );
  }
};

export const getDiagnosis = async (searchTerm: any) => {
  try {
    const response = await Axios.get(
      `${PATIENT_APIS.CGHS_NEW_DIAGNOSIS}/search?keyword=${searchTerm}`
    );

    return response?.data;
  } catch (error: any) {
    console.error("Cannot get diagnosis:", error);
    throw new Error(
      error?.response?.data
        ? typeof error?.response?.data === "string"
          ? error?.response?.data
          : "Please, Try again later"
        : "Please, Try again later"
    );
  }
};

export const getDiagnosisOptions = async () => {
  try {
    const response = await Axios.get(`${PATIENT_APIS.CGHS_NEW_DIAGNOSIS}`);

    return response?.data;
  } catch (error: any) {
    console.error("Cannot get diagnosis:", error);
    throw new Error(
      error?.response?.data
        ? typeof error?.response?.data === "string"
          ? error?.response?.data
          : "Please, Try again later"
        : "Please, Try again later"
    );
  }
};

export const getEnhancementReason = async () => {
  try {
    const response = await Axios.get(
      `${PATIENT_APIS.CGHS_NEW_ENHANCEMENT_REASON}`
    );

    return response?.data;
  } catch (error: any) {
    console.error("Cannot get enhancement reason:", error);
    throw new Error(
      error?.response?.data
        ? typeof error?.response?.data === "string"
          ? error?.response?.data
          : "Please, Try again later"
        : "Please, Try again later"
    );
  }
};

export const getResubmissionReason = async () => {
  try {
    const response = await Axios.get(
      `${PATIENT_APIS.CGHS_NEW_RESUBMISSION_REASON}`
    );

    return response?.data;
  } catch (error: any) {
    console.error("Cannot get resubmission reason:", error);
    throw new Error(
      error?.response?.data
        ? typeof error?.response?.data === "string"
          ? error?.response?.data
          : "Please, Try again later"
        : "Please, Try again later"
    );
  }
};

export const deleteDoctorNew = async (
  caseId: number,
  visitId: number,
  casePreAuthId: number,
  formData: any
) => {
  try {
    const response = await Axios.patch(
      `${PATIENT_APIS.CGHS_AB_NEW_SERVICE}/${caseId}/visitInfo/${visitId}/casePreAuthId/${casePreAuthId}/doctorDetail`,
      formData
    );
    return response.data;
  } catch (error: any) {
    console.error("Cannot delete doctor details:", error?.response?.data);
    throw new Error(error?.response?.data || "Cannot delete doctor details");
  }
};

export const registerValidation = async (data: any) => {
  try {
    const response = await Axios.post(
      `${PATIENT_APIS.CGHS_NEW_REGISTRATION}/validate`,
      data
    );
    return response.data;
  } catch (error: any) {
    console.error("Cannot validate registration details:", error?.response?.data);
    throw new Error(error?.response?.data || "Cannot validate registration details");
  }
};

export const getRegisterValidation = async (registrationId: any, visitId: any) => {
  try {
    const response = await Axios.get(
      `${PATIENT_APIS.CGHS_NEW_REGISTRATION}/${registrationId}/visitId/${visitId}`
    );
    return response.data;
  } catch (error: any) {
    console.error("Cannot get validation registration details:", error?.response?.data);
    throw new Error(error?.response?.data || "Cannot get validation registration details");
  }
};

export const updateRegistrationValidationDetails = async (caseId: any, visitId: any, data: any) => {
  try {
    const response = await Axios.patch(
      `${PATIENT_APIS.CGHS_NEW_REGISTRATION}/caseId/${caseId}/visitId/${visitId}/update`, data
    );
    return response.data;
  } catch (error: any) {
    console.error("Cannot update validation registration details:", error?.response?.data);
    throw new Error(error?.response?.data || "Cannot update validation registration details");
  }
};

export const fetchResubmissionDataServiceCghsNew = async (
  caseId: string | number,
  visitId: string | number
) => {
  const response = await Axios.get(
    `${PATIENT_APIS.CGHS_NEW_GET_RESUBMISSION_DATA}/${caseId}/visitInfo/${visitId}/resubmission`
  );
  return response.data;
};

export const saveResubmissionData = async (caseId: number | undefined, visitInfoId: number | undefined, payload: any): Promise<void> => {
  try {
    const apiUrl = `${PATIENT_APIS.CGHS_NEW_GET_RESUBMISSION_DATA}/${caseId}/visitInfo/${visitInfoId}/reSubmission`;
    const response = await Axios.post(apiUrl, payload);

    if (response.status !== 200 && response.status !== 201) {
      throw new Error("Failed to save resubmission data");
    }
  } catch (error) {
    console.error("Error saving resubmission data:", error);
    throw error;
  }
};

export const mobileVerify = async (caseId: number | undefined, visitId: number | undefined, payload: any): Promise<void> => {
  try {
    const apiUrl = `${PATIENT_APIS.PORTAL_REGISTRATION}/caseId/${caseId}/visitId/${visitId}/otp_verify`;
    const response = await Axios.post(apiUrl, payload);

   return response.data;
  } catch (error) {
    console.error("Error in otp verification:", error);
    throw error;
  }
};

export const otpVerify = async (caseId: number | undefined, visitId: number | undefined, payload: any): Promise<void> => {
  try {
    const apiUrl = `${PATIENT_APIS.PORTAL_REGISTRATION}/caseId/${caseId}/visitId/${visitId}/otp_verify`;
    const response = await Axios.post(apiUrl, payload);

   return response.data;
  } catch (error) {
    console.error("Error in otp verification:", error);
    throw error;
  }
};

export const register = async (caseId: number | undefined, visitId: number | undefined, payload: any): Promise<void> => {
  try {
    const apiUrl = `${PATIENT_APIS.PORTAL_REGISTRATION}/caseId/${caseId}/visitId/${visitId}/register`;
    const response = await Axios.post(apiUrl, payload);

   return response.data;
  } catch (error) {
    console.error("Error in registration:", error);
    throw error;
  }
};

export const downloadAbhinandanPatra = async (payload: any) => {
  try {
    const resp: any = await Axios.post<Blob>(
      `${API_URL}/api/cghs_new/download-mangal-kamna-patra`,
      payload,
      // {
      //   responseType: 'blob',
      // }
    );

    const base64String = resp.data;
      const binaryData = atob(base64String);
      const byteArray = new Uint8Array(binaryData.length);

      for (let i = 0; i < binaryData.length; i++) {
        byteArray[i] = binaryData.charCodeAt(i);
      }

      // Create a Blob from the byte array
      const fileBlob = new Blob([byteArray], { type: "application/pdf" });

      // Create a download link for the file
      const downloadLink = document.createElement("a");
      downloadLink.href = URL.createObjectURL(fileBlob);
      downloadLink.download = `Abhinandan Patra Form_${payload.registrationNumber}.pdf`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message ||
      "Cannot download abhinandan patra. Please try again later.";
      throw new Error(errorMsg);
  }
}

export const mobileVerifyCapf = async (caseId: number | undefined, visitId: number | undefined, payload: any): Promise<void> => {
  try {
    const apiUrl = `${PATIENT_APIS.OTP_VERIFI_CAPF}/caseId/${caseId}/visitId/${visitId}/otp_verify`;
    const response = await Axios.post(apiUrl, payload);

   return response.data;
  } catch (error) {
    console.error("Error in otp verification:", error);
    throw error;
  }
};

export const otpVerifyCapf = async (caseId: number | undefined, visitId: number | undefined, payload: any): Promise<void> => {
  try {
    const apiUrl = `${PATIENT_APIS.OTP_VERIFI_CAPF}/caseId/${caseId}/visitId/${visitId}/otp_verify`;
    const response = await Axios.post(apiUrl, payload);

   return response.data;
  } catch (error) {
    console.error("Error in otp verification:", error);
    throw error;
  }
};

export const fetchClaimIds = async (payload: any): Promise<void> => {
  try {
    const apiUrl = `${API_URL}/api/cghs_new/fetchPreauthToBeSubmitted`;
    const response = await Axios.post(apiUrl, payload);

   return response.data;
  } catch (error) {
    console.error("Error in fetching claim ids:", error);
    throw error;
  }
};

